/** @format */
import { CustomProductDao } from '@pdp/data-access/dao';
import { inject, Injectable } from '@angular/core';
import { MyCustomizerMap } from '@shared/data-access/interfaces';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class CustomProductService {
	private readonly customProductDao = inject(CustomProductDao);

	/**
	 * @param designId
	 * function to get the list of attributes for customized product
	 *
	 * @return list of customized attributes for the product
	 */
	public getCustomizedProductAttributes$(designId: string): Observable<MyCustomizerMap> {
		return this.customProductDao
			.loadCustomizedProductAttributes$(designId)
			.pipe(map((customAttrs: MyCustomizerMap) => customAttrs));
	}
}
